import { render, staticRenderFns } from "./forgot-password-confirm.vue?vue&type=template&id=7975b0ba&scoped=true&"
import script from "./forgot-password-confirm.vue?vue&type=script&lang=js&"
export * from "./forgot-password-confirm.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-confirm.vue?vue&type=style&index=0&id=7975b0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7975b0ba",
  null
  
)

export default component.exports